import { motion } from "framer-motion";
import { MENU } from "../../data/site";

const Card = ({ item, i }) => (
  <motion.div
    initial={{ opacity: 0, y: 34 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-40px" }}
    transition={{ duration: 0.6, delay: (i % 3) * 0.08, ease: [0.22, 1, 0.36, 1] }}
    data-testid={`menu-item-${item.id}`}
    className="group rounded-2xl border border-white/10 bg-white/[0.03] overflow-hidden hover:border-[#F59E0B]/40 transition-colors duration-500"
  >
    <div className="relative spotlight flex items-center justify-center aspect-square p-6">
      <img
        src={item.img}
        alt={item.name}
        loading="lazy"
        data-testid={`menu-image-${item.id}`}
        className="relative z-10 w-[82%] h-full object-contain drop-shadow-[0_22px_36px_rgba(0,0,0,0.55)] group-hover:scale-[1.06] transition-transform duration-500"
      />
    </div>
    <div className="p-6 pt-0">
      <div className="flex items-baseline gap-3">
        <span className="font-serif-e italic text-xl text-[#F59E0B]">{item.index}</span>
        <span className="text-[10px] tracking-[0.25em] uppercase font-bold text-[#BFAFA6]">
          {item.tagline}
        </span>
      </div>
      <h3 className="mt-1 font-display uppercase text-2xl lg:text-3xl text-[#F8F4EC] tracking-tight leading-none">
        {item.name}
      </h3>
      <p className="mt-3 text-sm text-[#BFAFA6] leading-relaxed">{item.desc}</p>
      <div className="mt-4 flex flex-wrap gap-2">
        {item.tags.map((t) => (
          <span
            key={t}
            className="px-3 py-1 rounded-full border border-white/15 text-[11px] tracking-wide text-[#F8F4EC]/80"
          >
            {t}
          </span>
        ))}
      </div>
    </div>
  </motion.div>
);

export const MenuShowcase = () => {
  return (
    <section
      id="menu"
      data-testid="menu-section"
      className="relative bg-[#1F1A18] px-6 lg:px-10 py-24 lg:py-32"
    >
      <div className="max-w-[1400px] mx-auto">
        <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-6 mb-14">
          <div>
            <span className="text-xs tracking-[0.3em] uppercase font-bold text-[#F59E0B]">
              The Menu
            </span>
            <h2 className="mt-5 font-display uppercase text-[#F8F4EC] text-5xl sm:text-6xl lg:text-7xl leading-[0.9]">
              Signature <br className="hidden sm:block" /> plates
            </h2>
          </div>
          <p className="max-w-sm font-serif-e italic text-xl text-[#BFAFA6]">
            Prepared to order, served in minutes. From vada pav to lassi — a
            full menu, made properly.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {MENU.map((item, i) => (
            <Card key={item.id} item={item} i={i} />
          ))}
        </div>
      </div>
    </section>
  );
};
